import { Messages } from '../../../../codegen/Localize';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IDeleteAction as IDeleteActionApi } from '../../../../ts/ServerApi/types/actionNames';
import { deleteContentsAction } from '../../../actions/spaces/DeleteContentAction';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { isSingleEmbeddedDatasource, userCanDeleteRunFlowTask, userCanEditSchedule, userCanManageAlerts } from './IEntityActionHelpers';

export const DeleteAction: IEntityAction<IContentInfo, IDeleteActionApi> = {
  name: EntityActionNames.Delete,
  translateName: Messages.delete_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !isSingleEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IDeleteActionApi, targetItems: IContentInfo[], state: AppState) => {
    return !!(availableActions && availableActions.del)
      || userCanManageAlerts(state, targetItems)
      || userCanEditSchedule(state, targetItems)
      || userCanDeleteRunFlowTask(targetItems);
  },
  createReduxAction: (targetItems: IContentInfo[]) => deleteContentsAction(targetItems)
};
